import React from 'react';
import ChangeContainer from './ChangeContainer';
import ActionSectionTitle from './ActionSectionTitle';
import IneligibleChange from './IneligibleChange';

/* eslint-disable react/display-name */
const Components = {
  ActionSectionTitle: (content: string) => () => <ActionSectionTitle content={content} />,
  ChangeContainer: (content: string | string[]) => () => <ChangeContainer content={content} />,
  IneligibleChange: () => () => <IneligibleChange />,
};


export default Components;
